import React, {useState,useEffect} from "react";
import PropTypes from "prop-types";
import { SFFormBuilder} from "@sf-core";

import getSchema from "./schema.js";
import uischema from "./uischema.json";
import TypeaheadRenderer, {
  TypeaheadControlTester,
} from "./typeaheadRenderer";

const NewUserForm = ({ onChange, data }) => {
  const [schema, setSchema] = useState(null);

  useEffect(async () => {
    setSchema(await getSchema());
  }, []);

  let customRenderers = [
    {
      renderer: TypeaheadRenderer,
      tester: TypeaheadControlTester,
    },
  ];

  if (!schema) {
    return null;
  }

  return (
    <SFFormBuilder
      schema={schema}
      uischema={uischema}
      data={data}
      onChange={onChange}
      customRenderers={customRenderers}
    />
  );
};

NewUserForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default NewUserForm;
